export const AUTH_TOKEN_FIELD_ORGANIZATIONS =
  "https://v1.panoscape.app/organizations";
